<app-auth-layout>
  <div class="w-full pb-32 pt-12">
    <img src="/assets/logo/full.svg" alt="logo-full" class="mb-10 w-40" />
    <p class="mb-0 w-full text-2xl">
      {{ "page.login.text" | translate }}
    </p>
    <p class="mb-8 mt-0 w-full">
      {{ "page.login.account" | translate }}
      <a class="text-primary" [routerLink]="networkService.isOnline() ? '/signup' : null">
        {{ "common.signup" | translate }}
      </a>
    </p>
    <asl-google-signin-button
      type="standard"
      size="large"
      theme="outline"
      shape="rectangular"
      [width]="300"
    />
    <p-divider align="center">
      {{ "common.or" | translate }}
    </p-divider>
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <app-alert
        *ngIf="errorAlertMessage"
        type="error"
        class="mb-10 block"
        [closable]="true"
        (whenClosed)="errorAlertMessage = ''"
      >
        <div>
          {{ "forms.login." + errorAlertMessage | translate }}
          <a
            *ngIf="errorAlertMessage === 'only-enterprise-user'"
            class="cursor-pointer underline"
            href="https://ionsapp.page.link/download"
            target="_blank"
          >
            {{ "forms.login.app-continue" | translate }}
          </a>
        </div>
      </app-alert>
      <app-input-text
        name="email"
        [label]="'common.email' | translate"
        [form]="loginForm"
        [required]="true"
        [errors]="getErrorMessage('email')"
      />
      <app-input-password
        name="password"
        [label]="'common.password' | translate"
        [form]="loginForm"
        [required]="true"
        [errors]="getErrorMessage('password')"
      />
      <a
        class="mb-4 flex justify-end text-primary"
        [routerLink]="networkService.isOnline() ? '/forgot-password' : null"
      >
        {{ "page.login.forgot-password" | translate }}
      </a>
      <p-button type="submit" color="primary" [loading]="loading">
        {{ "common.login" | translate }}
      </p-button>
    </form>
  </div>
</app-auth-layout>
